import React from 'react';
import { SectionLabel } from '@/components/common/SectionLabel';

export const PageHero = ({ label, title, intro, image, imageAlt }) => (
  <section className="bg-ophir-ivory-soft border-b border-ophir-grey">
    <div className="container-ophir py-14 lg:py-20">
      <div className={`grid gap-10 items-center ${image ? 'lg:grid-cols-2 lg:gap-16' : ''}`}>
        <div className={image ? '' : 'max-w-3xl'}>
          <SectionLabel>{label}</SectionLabel>
          <h1 className="mt-5 font-serif text-[38px] sm:text-[46px] lg:text-[56px] leading-[1.08] tracking-[-0.01em] text-ophir-navy-deep">{title}</h1>
          {intro && <p className="mt-6 text-[17px] lg:text-[18px] leading-relaxed text-ophir-muted max-w-[62ch]">{intro}</p>}
        </div>
        {image && (
          <div className="overflow-hidden rounded-2xl border border-ophir-grey shadow-ophir">
            <img src={image} alt={imageAlt} className="w-full h-full object-cover" width={1408} height={768} />
          </div>
        )}
      </div>
    </div>
  </section>
);
